import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { SelectableBox } from 'foundations-components/transitional/components/SelectableBox';
import { jsx as _jsx } from "react/jsx-runtime";
export const FeatureTile = ({
  feature,
  onSelectionChange
}) => {
  const {
    featureKey,
    isSelected,
    translationKey
  } = feature;
  return /*#__PURE__*/_jsx(SelectableBox, {
    selected: isSelected,
    onSelectedChange: evt => onSelectionChange(featureKey, evt.target.value),
    type: "checkbox",
    selectionMarkLocation: "left",
    paddingBlock: "0",
    paddingInlineEnd: "0",
    children: /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      flexDirection: "row",
      flexWrap: "wrap",
      inlineSize: "130px",
      blockSize: "80px",
      children: /*#__PURE__*/_jsx(View, {
        marginInlineStart: "300",
        children: /*#__PURE__*/_jsx(Text, {
          textAlign: "start",
          typography: "heading-50",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: translationKey
          })
        })
      })
    })
  }, featureKey);
};
export default FeatureTile;